import styles from './styles';
import { breakpoint } from '@core-ds/primitives';
import colors from './foundations/colors';
import fonts from './foundations/fonts';
import fontSize from './foundations/typography';
import radii from './foundations/radii';
import shadow from './foundations/shadow';
import space from './foundations/space';
import Avatar from './components/Avatar';
import Button from './components/Button';
import Modal from './components/Modal';
import Tabs from './components/Tabs';
import Tooltip from './components/Tooltip';
export const theme = {
   styles,
   breakpoints: { ...breakpoint, base: '0px', '2xl': '1536px' },
   colors,
   fonts,
   fontSizes: fontSize,
   radii,
   shadows: shadow,
   space,
   components: {
      Avatar,
      Button,
      Modal,
      Tabs,
      Tooltip,
   },
};
